import type { Action } from '../model'

import createReducer from '../createReducer'
import { Actions, type ScanSessionPurpose } from './types'







export interface ScanSessionReducer {
  scanSessionId: string | null
  /**
   * WHAT THE LIVE SESSION IS FOR — stored beside the id because the id alone cannot answer it,
   * and something outside the surface that opened the session has to.
   *
   * `ScanRoutingProvider` is mounted app-wide and watches this slice, so it sees EVERY session,
   * including the certificate one the Create Certificates modal opens. It reported its aim
   * against whatever id appeared here, which meant a certificate session was told `aimed: false`
   * the instant it opened (measured: 394ms after creation on dev) and the phone grew VRG-289's
   * "No destination is selected" banner on a minting run. The purpose is the only thing that
   * distinguishes the two, and it was thrown away by the saga.
   *
   * `null` while no session is open. Absent-as-certificate is NOT assumed here — a session with
   * no recorded purpose does not report an aim either, which is the safe direction.
   */
  scanSessionPurpose: ScanSessionPurpose | null
}

const defaultState: ScanSessionReducer = {
  scanSessionId: null,
  scanSessionPurpose: null,
}

export const scanSessionReducer = createReducer<ScanSessionReducer>(defaultState, {
  // Carries the whole slice, not just the id: the purpose has to land in the SAME dispatch, or
  // there is a render between them where a certificate session is indistinguishable from a
  // filter one — which is exactly the window `reportAim` fires in.
  [Actions.SET_SCAN_SESSION_ID]: (state: ScanSessionReducer, action: Action<ScanSessionReducer>) => ({
    ...state,
    scanSessionId: action.payload?.scanSessionId ?? null,
    scanSessionPurpose: action.payload?.scanSessionPurpose ?? null,
  }),
})
